export default {
  breadcrumbHome: {
    id: 'buyback_breadcrumb_home',
    defaultMessage: 'Trade-in home',
  },
}
